module.exports = __webpack_public_path__ + "static/media/book3.4790505d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/activity/inviteNew/book3.png
// module id = 1932
// module chunks = 6